<template>

    <fb-main-body>


        <fb-context-menu ref="ctxMenu">
            <ul class="nav-ctx-menu">
                <li v-if="checkedNodeData.code" @click="handleUpdateDept" >编辑部门</li>
                <li v-if="checkedNodeData.code" @click="handleDeleteDept" >删除部门</li>
                <li @click="handleAddChildDept">新增子部门</li>
            </ul>
        </fb-context-menu>

        <div class="org-manager">

            <div class="org-tree">

                <div class="fb-header">
                    <span class="title">机构目录</span>
                </div>

                <div class="tree-body">
                    <el-tree ref="tree" :highlight-current="true" :default-expand-all="true"  :expand-on-click-node="false" :data="treeData" :props="defaultProps" v-bind:key="code" @node-contextmenu="handleNodeContextMenu"
                             @node-click="handleNodeClick"></el-tree>
                </div>

            </div>

            <div class="emp-table">

                <div class="fb-header">
                    <span class="title">人员信息</span>

                </div>


                <div class="table-body">

                    <el-button-group style="float: left;margin-bottom: 20px">
                        <el-button size="medium" icon="el-icon-plus" @click="handleAddEmployee">新增员工</el-button>
                        <el-button size="medium" icon="el-icon-edit" @click="handleEditEmployee">编辑员工</el-button>
                        <el-button size="medium" icon="el-icon-delete" @click="handleBatchDelete">删除员工</el-button>
                    </el-button-group>

                    <el-table
                            @selection-change="handleSelectionChange"
                            :header-cell-style="{background:'#F2F6FC'}"
                            :data="tableData"
                            style="width: 100%">

                        <el-table-column
                                type="selection"
                                width="55">
                        </el-table-column>

                        <el-table-column
                                prop="name"
                                label="姓名"
                        >
                        </el-table-column>

                        <el-table-column
                                prop="name"
                                label="工号"
                        >
                        </el-table-column>

                        <el-table-column
                                prop="post"
                                label="岗位">
                        </el-table-column>

                      

                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="100">
                            <template slot-scope="scope">
                                <el-link type="primary" @click="handleEditEmployee(scope.row)" :underline="false">编辑</el-link>
                                <el-link type="danger" @click="handleDelete(scope.row)" :underline="false"
                                         style="margin-left: 10px;">删除
                                </el-link>
                            </template>
                        </el-table-column>

                    </el-table>

                    <el-pagination
                            v-if="pager.itemCount"
                            style="float: right;margin-top: 10px;margin-bottom: 10px;"
                            layout="prev, pager, next"
                            @current-change="handlePageChange"
                            :current-page="pager.pageIndex"
                            :page-size="pager.pageSize"
                            :total="pager.itemCount">
                    </el-pagination>





                </div>

            </div>

        </div>

    </fb-main-body>

</template>

<script>
    export default {
        name: "Index",
        components: {},
        props:{
            timestamp:{type:Number,default:function () {
                    return new Date().getTime()
                }},
        },
        data() {

            return {
                treeData: [{fullName: '组织机构树', children: []}],
                tableData:[],
                pager:{
                    itemCount:'',
                    pageIndex:1,
                    pageSize:9
                },
                defaultProps: {
                    children: 'children',
                    label: 'fullName'
                },
                checkedNodeData: {},
                checkedNode: {},
                form:{},
                selection:[],
                bodyMode:'table',
            }

        },
        watch:{
            checkedNode(){
               this.loadEmployee();
            },
            timestamp(){

            }
        },
        methods: {

            handleEditEmployee(e) {

                if(e && e.code){
                    this.$router.push({path:'/org-manager/edit-employee',query:{code:e.code,departmentCode:this.checkedNodeData.code}});
                    return;
                }

                if(!this.selection.length){
                    this.$message({type:'warning',message:'未选择记录'});
                    return ;
                }

                if(this.selection.length > 1){
                    this.$message({type:'warning',message:'一次只能编辑一条数据'});
                    return ;
                }

                this.$router.push({path:'/org-manager/edit-employee',query:{code:this.selection[0].code,departmentCode:this.checkedNodeData.code}});
            },
            handleDelete(row){


                let vm = this;

                vm.$confirm('您现在正在进行删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    vm.$http.post(vm.$api.employee.delete,vm.$qs.stringify({code:row.code,departmentCode:row.departmentCode})).then((resp)=>{
                        if(resp.data.status === 200){
                            vm.$message({type:'success',message:resp.data.desc});
                            vm.loadEmployee();
                        }else{
                            vm.$message({type:'error',message:resp.data.desc});

                        }
                    })



                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });

            },
            handleBatchDelete() {


                let vm = this;

                if(!this.selection.length){
                    this.$message({type:'warning',message:'未选择记录'});
                    return ;
                }


                let codes = [];

                this.selection.forEach((e)=>{
                    codes.push(e.code);
                });


                this.$confirm('您现在正在进行批量删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    vm.$http.post(this.$api.employee.batchDelete,{codes:codes,departmentCode:this.checkedNodeData.code}).then((resp)=>{
                        if(resp.data.status === 200){
                            vm.$message({type:'success',message:resp.data.desc});
                            vm.loadEmployee();
                        }else{
                            vm.$message({type:'error',message:resp.data.desc});

                        }
                    })



                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });




            },

            handleSelectionChange(selection){
                this.selection = selection;
            },

            handleAddEmployee(){

                window.handleAddEmployee = ()=>{
                    this.loadEmployee();
                };

                this.$router.push({path:'/org-manager/add-employee',query:{departmentCode: this.checkedNodeData.code}})
            },


            handleAddChildDept(){
                let vm = this;
                window.handleAddChildDept = function (data) {
                    vm.$refs.tree.append(data,vm.checkedNode);
                    delete  window.handleAddChildDept;
                };

                this.$router.push({path:'/org-manager/add-org',query:{parentCode:this.checkedNodeData.code}})
            },
            handleUpdateDept(){
                let vm = this;
                window.handleUpdateDept = function (data) {

                   Object.assign(vm.checkedNodeData,data);
                    delete  window.handleUpdateDept;
                };

                this.$router.push({path:'/org-manager/edit-org',query:{code:this.checkedNodeData.code}})
            },
            handlePageChange(e){
                this.pager.pageIndex = e;
                this.loadEmployee();
            },
            handleDeleteDept(){

                let vm = this;

                vm.$confirm('您现在正在进行删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    vm.$http.post(vm.$api.department.delete,vm.$qs.stringify({code:vm.checkedNodeData.code})).then((resp)=>{
                        if(resp.data.status === 200){
                            vm.$message({type:'success',message:resp.data.desc});
                            vm.$refs.tree.remove(vm.checkedNode);
                        }else{
                            vm.$message({type:'error',message:resp.data.desc});

                        }
                    })



                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });

            },

            handleNodeClick(){
                this.checkedNodeData = arguments[0];
                this.checkedNode = arguments[1];
            },
            handleNodeContextMenu() {
                this.checkedNodeData = arguments[1];
                this.checkedNode = arguments[2];
                this.$refs.ctxMenu.open(arguments[0])
            },
            loadOrgTree(){
                let vm = this;
                vm.$http.post(vm.$api.department.tree).then((resp) => {
                    vm.treeData[0].children = resp.data.data.departments;
                })
            },
            loadEmployee(){
                let vm = this;
                vm.$http.post(vm.$api.employee.list,vm.$qs.stringify(Object.assign({departmentCode:vm.checkedNodeData.code},vm.pager))).then((resp)=>{
                    vm.tableData = resp.data.data.employees ;

                    for(let key in vm.pager){
                        vm.pager[key] = resp.data.data.pager[key] ;
                    }

                })
            }
        },
        created() {


            //请求组织机构树
            let vm = this;
            vm.loadOrgTree();

        }
    }
</script>

<style lang="scss" scoped>


    .org-manager {
        border: #DCDFE6 solid 1px;
        overflow: hidden;
    }

    .org-tree {
        width: 299px;
        border-right: 1px solid #DCDFE6;
        height: 658px;
    }


    .org-tree, .emp-table {
        display: inline-block;
        float: left;
    }


    .tree-body {
        padding: 10px;

    }

    .emp-table {
        width: calc(100% - 300px);
    }

    .table-body {
        padding: 10px;
    }

    .fb-header {
        line-height: 30px;
        padding: 10px;
        border-bottom: #dcdfe6 solid 1px;

        .title {

        }

    }

    .nav-ctx-menu {
        padding: 0;
        list-style: none;
        background-color: #ffffff;
        font-size: 12px;
        line-height: 12px;
        text-align: left;
        color: #515a6e;

        li {
            border: 1px solid #dcdfe6;
            border-bottom: none;
            padding: 8px 20px;
            cursor: pointer;
        }

        li:last-child {
            border-bottom: 1px solid #dcdfe6;
        }

        li:hover {
            background-color: #dcdfe6;
        }

    }


</style>